<template>
  <v-text-field
    :model-value="modelValue"
    color="primary"
    variant="outlined"
    :label="fieldLabel"
    hide-details
    class="sw-search-field sw-float-field"
    v-bind="$attrs"
    @update:model-value="$emit('update:modelValue', $event)"
    @keyup.enter="onSearch"
  >
    <template #prepend-inner>
      <v-icon
        size="18"
        color="primary"
        class="sw-search-field__action-icon"
        role="button"
        tabindex="0"
        aria-label="Search"
        @click.stop="onSearch"
        @keydown.enter.stop="onSearch"
        @keydown.space.prevent="onSearch"
      >
        mdi-magnify
      </v-icon>
    </template>
    <template v-if="showClear" #append-inner>
      <v-icon
        size="18"
        color="primary"
        class="sw-search-field__action-icon"
        role="button"
        tabindex="0"
        aria-label="Clear search"
        @click.stop="onClear"
        @keydown.enter.stop="onClear"
      >
        mdi-close
      </v-icon>
    </template>
    <template v-else-if="$slots['append-inner']" #append-inner>
      <slot name="append-inner" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "SwSearchField",
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: "" },
    placeholder: { type: String, default: "Search" },
    label: { type: String, default: undefined },
    clearable: { type: Boolean, default: false },
    searching: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "clear", "search"],
  computed: {
    fieldLabel() {
      return this.label || this.placeholder || "Search";
    },
    showClear() {
      return this.clearable && (this.searching || !!this.modelValue);
    },
  },
  methods: {
    onClear() {
      this.$emit("update:modelValue", "");
      this.$emit("clear");
    },
    onSearch() {
      this.$emit("search", this.modelValue);
    },
  },
};
</script>
